<template>
    <div>
      <div v-if="selectedContentPromptsSignals?.length">
        {{ `${selectedContentPromptsSignals.length} elements selected` }}
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        Not set
      </div>
    </div>
</template>

<script>
import {
  STEPS,
} from "@/components/FullPageSourceEditorV2/components/AiWriter/constants.js";

export default {
    name: 'ConfigPreviewRichContent',
    props: [
      'selectedContentPromptsSignals',
    ],
    computed: {
        STEPS() {
          return STEPS
        },
    }
}
</script>

<style lang="scss" scoped>

</style>